import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Menu from './Menu';

const Layout = (props) => {

  const [email, setEmail] = useState("");

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    setEmail(user.email)
  }, [])
  


  return (
    <div className="App" align="left">

      <div className='title_header'>
        <table width="100%">
          <tr>
            <td align="left" >{props.header}</td>
            <td align="right">
              <div align="right" style={{paddingRight:"20px"}}>
                <div className='title_login'>Logged in as</div>
                <div className='title_email'>{email}</div>
              </div>

            </td>
          </tr>
        </table>
      </div>

      <div align='left'>
        <div className="container" >
          <div className="menu menu_side_bar" align='left'><Menu id={props.id}/></div>
          <div className="main-content"><Outlet /></div>
        </div>
      </div>

      <div>
        <div align="left" className='footer_text'>iZeeM - NUS SORTING BINS</div>
      </div>
    </div>
  )
}

export default Layout